<script setup>
	import { ref, computed, defineProps, defineEmits } from 'vue';
	import { formConfig } from '@/js/formConfig.js';

	import { useStore } from 'vuex';
	const store = useStore();

	const emit = defineEmits(['choosenCoupons']);

	// eslint-disable-next-line no-unused-vars
	const choosenCouponsId = ref([]);

	defineProps({
		couponsList: {
			type: Object,
			required: true
		},
	});

	// eslint-disable-next-line no-unused-vars
	const lang = computed(() => store.getters.getLocale.slice(0, 2));

	// const images = import.meta.glob('../assets/img/coupons/*.png', {eager: true}); // only in Vite
	const images = require.context('../assets/img/coupons/', false, /\.png$/);

	// eslint-disable-next-line no-unused-vars
	const getImageCoupon = (gcn) => {
		const imageName = `./${gcn}.png`;
		if (images.keys().includes(imageName)) {
			return images(imageName);
		}
		return images('./notfound.png');
	};

	// eslint-disable-next-line no-unused-vars
	const toggleCouponId = id => {
		// We add or remove ids in the list.
		if(choosenCouponsId.value.includes(id)){
			// User clicked on already selected coupon => We remove this specific one
			const i = choosenCouponsId.value.indexOf(id);
			choosenCouponsId.value.splice(i, 1);
		}else{
			if(howManyCouponsUserCanChoose === 0){
				choosenCouponsId.value.push(id);
			} else if(choosenCouponsId.value.length >= howManyCouponsUserCanChoose){
				choosenCouponsId.value.shift(); // remove the first element
				choosenCouponsId.value.push(id);
			}else{
				choosenCouponsId.value.push(id);
			}
		}
				// If id present, the coupon looks "active" on the form.
				// Each time, we emit the full array to the form
				emit('choosenCoupons', choosenCouponsId); // to inform the form
			};

			const howManyCouponsUserCanChoose = formConfig.howManyCouponsUserCanChoose;
		</script>














		<template>
			<div id="couponchooser">

				<h2 v-html="$t('sectionTitles.chooseYouCoupon')"></h2>

				<div class="maxAllowed" v-if="howManyCouponsUserCanChoose < couponsList.length">
					<p>{{ $t('couponChooser.maxAllowed') }}: {{ howManyCouponsUserCanChoose }}</p>
				</div>

				<div class="couponGrid">

					<button class="card couponCard" v-for="(coupon, index) in couponsList" :key="`kl-${index}`" :class="{'active': choosenCouponsId.includes(coupon.id)}" @click="toggleCouponId(coupon.id)">

						<img :src="getImageCoupon(coupon.gcn)" :alt="`${coupon.gcn}.png`">

						<div class="bigPrice">
							<span v-if="['nl', 'en'].includes(lang)">€</span> {{ coupon.value }} <span v-if="['fr'].includes(lang)">€</span>
						</div>
						<span> {{ $t('couponChooser.discount') }}</span>

						<div class="description">
							{{ coupon.description }}
						</div>

						<div class="availables">
							{{ $t('couponChooser.still') }} {{ coupon.offersStillAvailableCounter }} {{ $t('couponChooser.available') }}<span v-if="lang==='fr' && parseInt(coupon.offersStillAvailableCounter) > 1">s</span>
						</div>

						<span style="display: none;">Expire on: {{coupon.onlineenddate}}</span>


					</button>

				</div>

			</div>
		</template>











		<style scoped>

			#couponchooser {}

			.maxAllowed {
				text-align: center;
				margin-bottom: 2em;
				p {
					padding: 0.5em 4em;
					display: inline-block;
					background: #00f3;
					border-radius: 0.5em;
				}
			}

			.couponGrid {
				/* This grid is a flex, I know… */
				display: flex;
				flex-direction: row;
				flex-wrap: wrap;
				gap: 1.5em;
				justify-items: center;
				align-items: stretch;
				justify-content: center;
			}

			.couponCard {

				/* Contradict button style */
				background: #fff;
				color: #000;
				border: none;

				&:hover {
					background: #fff;
					color: #000;
				}

				cursor: pointer;

				display: flex;
				flex-direction: column;
				justify-content: space-between;
				align-items: center;

				width: 100%;
				max-width: 40ch;

				border: 3px solid #0003;
				border-radius: 8px;
				padding: 0.5em;

				transition: border 0.3s ease-in-out, scale 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
				scale: 0.95;
				box-shadow: 0 0px 0px #0003;

				&.active {
					border: 3px solid var(--client-color-2);
					scale: 1;
					box-shadow: 0 4px 16px #0003;
				}

				.bigPrice {
					text-align: center;
					color: var(--client-color-2);
					font-size: 3em;
					font-weight: bold;
				}

				.description {
					padding: 1em 0;
					min-height: 5em;
				}

				img {
					width: 100%;
					aspect-ratio: 568/400;
					background: #0002;
					border-radius: 4px;
				}
				.availables {
					font-size: 0.85em;
					color: #0009;
					text-align: center;
					margin-top: 0.5em;
				}
			}

			.noChoiceMade {
				text-align: center;
				font-size: 0.9em;
				color: #0009;
				padding-top: 1em;
			}

		</style>